$(document).ready(function () {
  // Fancybox v3 with thumbnails
  $("[data-fancybox='gallery']").fancybox({
  helpers: {
    thumbs: {
      width: 60,
      height: 60
    }
  },
  openEffect: "elastic",
  closeEffect: "elastic"
});

  // Swiper
  const mySwiper = new Swiper(".media_swiper_wrapper", {
    loop: false,
    slidesPerView: 1,
    spaceBetween: 0,
    centeredSlides: false,
    autoplay: false,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev"
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true
    }
  });
  $(document).on('click', '.product__info-wrapper .product-form__input--pill input[type=radio]+label', function(){
    // alert("clicked");
    setTimeout(function(){
      $('.swiper-pagination .swiper-pagination-bullet:first-child').trigger('click');
    },600)
    
  })
  $(document).on('click', '.variant_bg_prd_page', function(event){
    // setTimeout(function(){
    //   $(this).trigger('click');
    // },1000)
    
    // event.preventDefault();
   // var masterImg = $(this).attr('master_img');
      // $('.product__media-item_first_slide_box .product__mediaaaa img').attr('src', masterImg);
      // $('.product__media-item_first_slide_box .product__mediaaaa img').attr('srcset', masterImg);
       //$('#firstPrdImgMain').hide();
      // 
      
        // $('.media_swiper_wrapper').addClass('hide_default_img');
        //$('#firstPrdImgMainChange').attr('src', masterImg);
        $('#firstPrdImgMainChange').hide();
      
      // alert(masterImg);
  })
  setTimeout(function(){
    $('.gallery_video_box_thumb').each(function(){
      var videosrc = $(this).attr('video_src');
      $(this).next().attr('src', videosrc);
      $(this).hide();
    });
  },2000)
  
  
});
// document.addEventListener('DOMContentLoaded', function () {
//   setTimeout(function () {
//     new Swiper('.media_swiper_wrapper', {
//       slidesPerView: 1,
//       spaceBetween: 0,
//       loop: false,
//       autoplay: false,
//       navigation: {
//         nextEl: '.swiper-button-next',
//         prevEl: '.swiper-button-prev',
//       },
//       pagination: {
//         el: '.swiper-pagination',
//         clickable: true
//       }
//     });
//   }, 200); // delay helps if DOM is still rendering
// });
